export const files = (state) => state?.input?.exposure?.premDeduct?.files || [];
export const note = (state) => state?.input?.exposure?.premDeduct?.note || null;
